import { User, BAFTA_USERNAME } from "@ecologi/shared";
import React from "react";
import useMedia from "react-use/lib/useMedia";
import { ForestWrapper, Wrapper } from "./OmniForestComponents";
import { ForestTitleBox } from "./components/ForestTitleBox";
import { GrassTuftsBackground } from "./components/GrassTuftsBackground";

export type OmniForestProps = {
  children: React.ReactNode;
  isOwnProfile: boolean;
  onEditTitle: (payload: any) => Promise<any>;
  profile: User;
  user: User | null;
};

export const OmniForest = ({
  children,
  isOwnProfile,
  onEditTitle,
  profile,
  user,
}: OmniForestProps) => {
  const mobileUp = useMedia("(min-width: 480px)", true);

  const isForestHidden = profile.username === BAFTA_USERNAME;

  return (
    <div>
      <div id="forest">
        <ForestWrapper>
          <Wrapper
            data-testid="profile-forest-section"
            isForestHidden={isForestHidden}
          >
            {!isForestHidden && (
              <>
                <ForestTitleBox
                  onEditTitle={onEditTitle}
                  user={user}
                  profile={profile}
                  isOwnProfile={isOwnProfile}
                />

                {children}
                {mobileUp && <GrassTuftsBackground />}
              </>
            )}
          </Wrapper>
        </ForestWrapper>
      </div>
    </div>
  );
};
